<template>
	<Transition name="fade">
		<div v-if="shouldDisplayInfoBar" class="fixed bg-blue-500 top-0 inset-x-0 py-2 md:py-6 z-[999]" role="alert">
			<div class="container flex items-center text-body-primary">
				<div class="flex flex-col md:flex-row gap-1 md:gap-2 md:justify-center md:items-center flex-1">
					<span>
						Vaše pobočka byla změněna na
					</span>
					<span class="flex items-center gap-1.5 font-bold">
						<NuxtIcon name="custom/house" class="text-lg" filled aria-hidden="true" />
						{{ selectedHypermarketInstance?.content?.name }}
					</span>
				</div>
				<button class="flex-none" aria-label="Zavřít oznámení" @click="toggleVisible()">
					<NuxtIcon name="x" class="text-[28px] text-body-primary" filled aria-hidden="true" />
				</button>
			</div>
		</div>
	</Transition>
</template>

<script setup lang="ts">
	import {storeToRefs} from 'pinia';
	import {useStoryblokHypermarketsStore} from '@/stores/storyblokHypermarkets';
	import {HYPERMARKET_CHANGE_FLAG_COOKIE} from '#shared/constants';

	const [visible, toggleVisible] = useToggle(false);

	const hypermarketsStore = useStoryblokHypermarketsStore();
	const {selectedHypermarket, selectedHypermarketInstance} = storeToRefs(hypermarketsStore);

	const hypermarketChangedFlag = useCookie(HYPERMARKET_CHANGE_FLAG_COOKIE, {default: () => false});

	const {start: startAutoClose, stop: stopAutoClose} = useTimeoutFn(() => {
		toggleVisible(false);
	}, 4000, {immediate: false});

	const shouldDisplayInfoBar = computed(() => visible.value && selectedHypermarketInstance.value?.content?.name);

	watch(visible, (newValue) => {
		if (newValue === true) {
			startAutoClose();
		} else {
			stopAutoClose();
		}
	});

	watch(selectedHypermarket, (newValue, oldValue) => {
		if (oldValue && oldValue !== newValue) {
			toggleVisible(true);
		}
	});

	onMounted(() => {
		if (hypermarketChangedFlag.value) {
			toggleVisible(true);
			hypermarketChangedFlag.value = false;
		}
	});

	watch(hypermarketChangedFlag, (newValue) => {
		if (newValue) {
			toggleVisible(true);
			nextTick(() => {
				hypermarketChangedFlag.value = false;
			});
		}
	});
</script>
